// Sidebar dimensions — shared with Layout.js and TopBar.js
export const EXPANDED = 280
export const COLLAPSED = 60
